import Vue from 'vue'
import BaseComponent from '@base/component'

export default Vue.extend({
    mixins: [ BaseComponent ]
});
